/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

/*
  Add the polyfill for <picture> to be usable in IE11
  Note - used commonJS require here because file needs to be 
  either all commonJS , or all ES6
*/
const picturefill = require('picturefill')

exports.onClientEntry = () => {
  picturefill()
}
